interface statusListProps {
  isFree: boolean
  Free: boolean
  Essential: boolean
  Professional: boolean
  Enterprise: boolean
  showReminderModel: boolean
}

export enum PlanEnum {
  Free = "Free",
  Essential = "Essential",
  Professional = "Professional",
  Enterprise = "Enterprise",
}

export type { statusListProps }
